(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/progress-bar/assets/react/hooks/use-time-diff.js') >= 0) return;  svs.modules.push('/components/numbergames/progress-bar/assets/react/hooks/use-time-diff.js');

'use strict';

const {
  useEffect,
  useRef,
  useCallback
} = React;
const timeDiff = time => time ? Math.round((Date.now() - time) / 1000) : 0;
const useTimeDiff = (startTimeProp, resetTimeProp) => {
  const timeRef = useRef(null);
  useEffect(() => {
    timeRef.current = null;
  }, [resetTimeProp]);
  useEffect(() => {
    if (startTimeProp) {
      timeRef.current = Date.now();
    }
  }, [startTimeProp]);
  return useCallback(() => timeDiff(timeRef.current), []);
};
svs.numbergames.progress_bar.hooks.useTimeDiff = useTimeDiff;

 })(window);